export enum CargoType {
  FLC = "FLC",
  PALLETIZED = "PALLETIZED",
}
